import { useEffect, useCallback, useState } from "react";
import axiosInstance from "../api/axiosInstance";

export const useDriverTrackerStatus = (taskId) => {
  const [driverStatus, setDriverStatus] = useState(undefined);
  const [merchantStatus, setMerchantStatus] = useState(undefined);

  const fetchTrackerStatus = useCallback(async () => {
    if (!taskId) return;

    // console.log(" getDriverTrackerStatus CALL");

    const res = await axiosInstance.post(
      "/api/DriverTracker/v1.0/getDriverTrackerStatus",
      { taskId }
    );

    if (res?.data?.responseCode !== "00") return;

    const row = res.data.data?.[0];
    if (!row) return;

    const rawStatus = row.status?.toLowerCase();
    const rawMerchant = row.merchant_order_status?.toLowerCase();

    let mappedDriverStatus;
    let mappedMerchantStatus;

    /* ---------------- DRIVER STATUS MAPPING ---------------- */

    if (
      ["assigned", "acknowledged", "arrived", "picked up", "successful"].includes(rawStatus)
    ) {
      mappedDriverStatus = rawStatus;
    }

    //  SPECIAL CASE: food is ready
    if (rawStatus === "food is ready") {
      mappedDriverStatus = "acknowledged";
    }

    /* ---------------- MERCHANT STATUS MAPPING ---------------- */

    if (rawMerchant) {
      mappedMerchantStatus = rawMerchant;
    }

    // fallback (safety)
    if (!mappedMerchantStatus && rawStatus === "food is ready") {
      mappedMerchantStatus = "food is ready";
    }

    console.log(" Tracker STATUS MAPPED:", {
      rawStatus,
      rawMerchant,
      mappedDriverStatus,
      mappedMerchantStatus,
    });

    setDriverStatus(mappedDriverStatus);
    setMerchantStatus(mappedMerchantStatus);
  }, [taskId]);

  //  FIRST LOAD
  useEffect(() => {
    if (!taskId) return;
    fetchTrackerStatus();
  }, [taskId, fetchTrackerStatus]);

  return {
    driverStatus,
    merchantStatus,
    refetchStatus: fetchTrackerStatus,
  };
};
